import { css } from '@emotion/react';
import { CSSProperties } from 'react';
import { colors } from './colors';

export const transparentBgStyle: CSSProperties = {
  background:
    'radial-gradient(100% 204.54% at 0% 0%, rgba(249, 250, 250, 0.8) 0%, rgba(255, 255, 255, 0.32) 100%)',
};

/** The tint on a derived figure beside recorded ones, as the Cap Table's metric-sourced KPIs. */
export const derivedBgStyle: CSSProperties = {
  background:
    'radial-gradient(100% 204.54% at 0% 0%, rgba(234, 244, 251, 0.8) 0%, rgba(200, 209, 249, 0.32) 100%)',
};

export const cardBorderStyles: CSSProperties = {
  borderRadius: '4px',
  border: `1px solid ${colors.neutral[80]}`,
};

export const cardStyles: CSSProperties = {
  ...cardBorderStyles,
  ...transparentBgStyle,
  padding: '0.5rem 1rem',
};

export const borderStyle = {
  borderRadius: '4px',
  border: `1px solid ${colors.neutral[80]}`,
};

export const flatCardStyleNewCss = css({
  ...borderStyle,
  padding: '0.5rem 1rem',
});

export const borderedSectionCss = css({
  border: '1px solid var(--mui-colors-neutral-30)',
  borderRadius: '8px',
  padding: '1rem',
});

export const elevatedCardStyleCss = css({
  ...borderStyle,
  boxShadow:
    '0px 24px 48px 0px rgba(75, 82, 93, 0.02), 0px 4px 24px 0px rgba(16, 37, 62, 0.04), 0px -4px 40px 0px rgba(255, 255, 255, 0.06)',
  padding: '0.5rem 1rem',
});

/** Text for screen readers only: the standard visually-hidden recipe (MUI's `visuallyHidden`), hence raw values. */
export const visuallyHiddenCss = css({
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px',
});

export const baseFormInlineClassNames = 'form-control form-inline';
export const formSelectInlineClassNames = `${baseFormInlineClassNames} form-inline-select`;
export const formTextFieldInlineClassNames = `${baseFormInlineClassNames} form-inline-input`;

/**
 * Collapse AgGrid's auto-height viewport floor so populated grids hug their rows.
 * Apply only when rows exist — empty grids keep the default floor so the no-rows
 * overlay has room.
 */
export const gridHugRowsCss = css`
  .ag-layout-auto-height .ag-grid-scrolling-rows {
    min-height: 36px;
  }
`;
